import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoordinatesPerson = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4M4 8v1h2v2.75s.75.25 2 .25 2-.25 2-.25V9h2V8a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M.838 10.13c.322-.326.719-.61 1.162-.852V12c0 .076.032.232.262.465.234.238.623.497 1.182.737C4.56 13.68 6.17 14 8 14s3.44-.32 4.556-.798c.56-.24.948-.5 1.182-.737.23-.233.262-.389.262-.465V9.278c.443.243.84.526 1.162.852.478.484.838 1.117.838 1.87 0 .752-.36 1.385-.838 1.87-.474.48-1.11.867-1.818 1.17-1.419.608-3.309.96-5.344.96s-3.925-.352-5.344-.96c-.707-.303-1.344-.69-1.818-1.17C.36 13.385 0 12.752 0 12s.36-1.386.838-1.87"
	})]
});
export default SvgCoordinatesPerson;
